import * as React from 'react';
const SvgArrowTurnUpRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M18.95 9.685c-.07-.23-.81-.96-1.52-1.671l-1.66-1.661c-.2-.2-.3-.3-.41-.33a.55.55 0 0 0-.31 0c-.11.04-.21.14-.41.33l-.28.28-.19.19c-.08.08-.12.15-.14.22-.03.1-.03.21 0 .31.04.11.14.21.33.41l1.23 1.232H11c-2.76 0-5 2.241-5 5.003V17.2c0 .28 0 .42.05.53.05.09.12.17.22.22.11.05.25.05.53.05h.4c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-3.202a2.997 2.997 0 0 1 3-3.002h4.59l-1.23 1.23c-.2.2-.3.3-.33.411-.03.1-.03.21 0 .31.04.11.14.21.33.41l.28.28c.13.13.22.22.3.28a.3.3 0 0 0 .11.06c.1.031.21.031.31 0 .11-.04.21-.14.41-.33l1.66-1.66c.71-.71 1.44-1.441 1.52-1.672a1 1 0 0 0 0-.62z"
    />
  </svg>
);
export default SvgArrowTurnUpRight;
